import React from 'react';
import { useState, useEffect, forwardRef } from 'react';
import { getStore, usePlayerStore, useLayoutStore } from '../../../stores/StoreContext';
import CONSTANTS from '../../../config/constants';

const Playhead = forwardRef((props, ref) => {
  const PlayerStore = getStore('playerStore');

  {
    /* Listen to any changes in the stores... */
  }
  const duration = usePlayerStore((state) => state.duration);
  const currentTime = usePlayerStore((state) => state.currentTime);
  const isLive = usePlayerStore((state) => state.isLive);
  const dragging = usePlayerStore((state) => state.dragging);
  const displayMarkers = usePlayerStore((state) => state.displayMarkers);
  const scrubTime = usePlayerStore((state) => state.scrubTime);
  const mediaControlsElement = useLayoutStore((state) => state.containers.controls.element);

  const [refBounds, setRefBounds] = useState(null);
  const [controlsHeight, setControlsHeight] = useState(0);

  // Track the height of the media controls element
  useEffect(() => {
    if (!mediaControlsElement) return;

    const updateHeight = () => {
      setControlsHeight(mediaControlsElement.offsetHeight - 10);
    };

    // Initial height
    updateHeight();

    // Observe size changes
    const resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(mediaControlsElement);

    return () => {
      resizeObserver.disconnect();
    };
  }, [mediaControlsElement]);

  const handleMouseDown = (e) => {
    // pause the video
    PlayerStore.setPlaying(false);
    PlayerStore.setDragging(true);
    PlayerStore.setScrubTime(currentTime);
    setRefBounds(ref.current.getBoundingClientRect());
  };

  const handleMouseUp = () => {
    //if (!dragging) return;
    PlayerStore.setDragging(false);
    PlayerStore.seekVideoTo(currentTime);
    PlayerStore.setPlaying(true);
  };

  const handleMouseMove = (e) => {
    if (!dragging) return;

    let relativeX = e.clientX - refBounds.left;
    relativeX = Math.max(0, Math.min(relativeX, refBounds.width));
    let newTime = (relativeX / refBounds.width) * duration;
    newTime = Math.round(newTime);

    // If the new time is the duration they want to flip to live....
    if (newTime === duration) {
      //PlayerStore.setActiveVideoSource(CONSTANTS.VIDEO_SOURCES.LIVE)
    } else {
      PlayerStore.setScrubTime(newTime);
      PlayerStore.setCurrentTime(newTime);
      PlayerStore.onSeek(newTime);
    }
  };

  const handleClickNav = (e) => {
    const rect = ref.current.getBoundingClientRect();
    let relativeX = e.clientX - rect.left;
    relativeX = Math.max(0, Math.min(relativeX, rect.width));
    const newTime = (relativeX / rect.width) * duration;
    console.log('click Nav');
    PlayerStore.setActiveVideoSource(CONSTANTS.VIDEO_SOURCES.RECORDED);
    PlayerStore.setCurrentTime(newTime);
    PlayerStore.onSeek(newTime);
  };

  const handleStyle = {
    position: 'absolute',
    top: '12px', // adjust vertical position as needed
    //left: `${(currentTime / duration) * 100}%`,
    left: `${(dragging ? scrubTime / duration : currentTime / duration) * 100}%`,
    width: '16px',
    height: '16px',
    borderRadius: '50%',
    background: '#fff',
    border: '1px solid #333',
    cursor: 'pointer',
    zIndex: 9000,
    transform: 'translateX(-50%)',
    display: `${isLive ? 'none' : 'block'}`,
  };

  const handleLineStyle = {
    position: 'absolute',
    top: '12px', // adjust vertical position as needed
    left: `${(dragging ? scrubTime / duration : currentTime / duration) * 100}%`,
    width: `${displayMarkers.length ? '1px' : '0px'}`,
    height: `${controlsHeight}px`,
    background: '#000',
    cursor: 'pointer',
    zIndex: 8999,
    display: `${isLive ? 'none' : 'block'}`,
  };

  return (
    <>
      <div
        style={handleStyle}
        onMouseDown={handleMouseDown}
        onMouseMove={handleMouseMove}
        onMouseUp={handleMouseUp}
        onMouseLeave={handleMouseUp}
        onClick={handleClickNav}
        id="playback-handle"
      />
      <div style={handleLineStyle} id="playback-handle-line"></div>
    </>
  );
});

export default Playhead;
